<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer008">
<h2 class="cn" id="_idParaDest-3"><a id="_idTextAnchor002"></a><a href="#/text/9780062693457_Contents#r_idParaDest-3"><span class="right_1" epub:type="pagebreak" id="page_1" title="1">Prologue</span></a></h2>
<p class="disp"><b>ARCHER DAILY TRIBUNE</b></p>
<div class="hide"><hr/></div>
<p class="hl">Hundreds of Children Perish in New London School Explosion</p>
<p class="artcl_f_l"><i>New London, Tex., March 18, 1937—</i></p>
<p class="artcl_f">At 3:20 this afternoon, as nearly seven hundred children and teachers finished the school day before what was to be a long weekend, an explosion ripped through the new Consolidated School, reducing one entire wing to rubble. Fire immediately erupted, the roof caved in, walls tumbled down, and the ground shook for miles around. Those close to the school at the time of the disaster mistakenly believed that a bomb had gone off, and within moments, dozens of bystanders had rushed to the aid of the injured and dying.</p>
<p class="artcl"><span class="right_1" epub:type="pagebreak" id="page_2" title="2">At the time of this writing, over four hundred bodies have been counted, and fewer than one hundred injured survivors have been accounted for. Many others are still missing.</span></p>
<p class="artcl">Help continues to pour in from Texas, Louisiana, and beyond. Hundreds of workers rushed from the busy East Texas oil fields to lend assistance, armed with torches and tools. They are joined by doctors, nurses, coroners, and undertakers who continue to arrive by automobile and train and seemingly every other form of conveyance. National Guardsmen have established martial law at the order of Gov. James V. Allred.</p>
<p class="artcl">The cause of the disaster has yet to be determined. Had the explosion been delayed but a few hours, the school would have stood silent and empty, and hundreds of souls would have been saved.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062693457_Prologue.vue?413fdaaa